import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {Button} from '@customink/pigment-react';
import {metrics} from '~/vendor/metrics';
import Notification from '~/components/Notification';
import {getNotification} from '~/selectors/NotificationSelectors';

import './PrintMethodWarning.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function ChangePrintMethodWarning(props) {
  const notification = useSelector(getNotification);

  useEffect(() => {
    metrics.pageViewTag('/ndx/printmethod/warning/changeprintmethod');
  }, []);

  const handleChangePrintMethod = () => {
    metrics.fireEvent(
      'print method warning',
      'change print method',
      'confirmation'
    );
    notification?.onConfirm?.();
    props.dismiss();
  };

  const handleCancel = () => {
    metrics.fireEvent(
      'print method warning',
      'change print method',
      'cancelled'
    );
    props.dismiss();
  };

  return (
    <Notification {...props} dismiss={handleCancel} title="Change Print Method">
      <p className="ndx-cta1">
        The size or placement of your design may shift when you change your
        print method. Make sure to check that everything looks right before
        placing your order.
      </p>
      <Button
        size="large"
        className="ndx-PrintMethodWarning-changeBtn"
        onClick={handleChangePrintMethod}>
        Change Print Method
      </Button>
      <Button
        variant="link"
        className="ndx-PrintMethodWarning-cancelLink"
        onClick={handleCancel}>
        Cancel
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

ChangePrintMethodWarning.propTypes = propTypes;

ChangePrintMethodWarning.displayName = 'ChangePrintMethodWarning';
